import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Box} from 'reactjs-admin-lte'
import {Button,ButtonToolbar,SplitButton,MenuItem,ControlLabel,InputGroup,FormGroup,Row,Col,FormControl} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import PNDocStore from '../../stores/PNDocStore'
import SWTNewCustomerPopup from '../workdoc/SWTNewCustomerPopup'
import DatePicker from '../../component/element/DatePicker'
import IframeModal from '../../component/element/IframeModal'


var NotificationSystem = require('react-notification-system');

const DEFAULT_ROW = 3
class PaymentNoteDoc extends Component {

  constructor(...args){
    super(...args)

    this.state = this.initState()
    this.pcInput = new Array(DEFAULT_ROW).fill('')
  }

  initState(newState){
    
    let state = {loading:false,showHistory:false,pnNo:'',workNo:'',show:false,shopName:'',rowBeep:-1,data:this.newEmptyRow(DEFAULT_ROW),options:[],doc:this.getEmptyDoc(),docType:'paymentnote'}

    if(newState!==undefined){
      state = Object.assign(state,newState)
    }
    return state
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this._iframe = this.refs.iframe
  }

  componentWillMount() {
    // Instantiate a Realtime client 
  }

  renameDoc(newSoNo){
    let {doc} = this.state
    doc['payment_note_no'] = newSoNo
    this.setState({pnNo:newSoNo,doc:doc})
  }

  newEmptyRow(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {itemnum:'',productcode:'',detail:'',stock_quantity:'',quantity:'',price_per_unit:'',amount:''}
    })
  }

  getEmptyDoc(){
    return {amount:0,customer_name:'',customer_address:'',customer_tel:'',remark:'',status:'',stock_recordid:'',canceled:0}
  }

  loadNewDoc(callback){
    // let {loading} = this.state
    
    this.setState(this.initState({loading:true}))
    PNDocStore.newPNDoc((result)=>{            
      let data = this.newEmptyRow(DEFAULT_ROW)
      this.setState({loading:false,pnNo:result.data.doc.payment_note_no,doc:result.data.doc,data:data})
      if(callback!==undefined){
        callback(result.data.doc)
      }
    })
  }

  loadNewDocCreditInstallment(workNo,item,index,noOfPayment,docType,callback){
    // let {loading} = this.state
    
    this.setState(this.initState({loading:true,workNo:workNo}))
    PNDocStore.newPNDocCreditInstallment(workNo,docType,(result)=>{            
      let data = [{detail:'ผ่อนชำระ งวด '+(index+1)+'/'+noOfPayment, price_per_unit:item.amount,quantity:1,amount:item.amount}]
      
      this.setState({loading:false,pnNo:(docType==='cashbill'?result.data.doc['cashbill_no']:result.data.doc['payment_note_no']),doc:result.data.doc,data:data,docType:docType})
      if(callback!==undefined){
        callback(result.data.doc)
      }
    })
  }

  loadData(pnNo,docType,shouldFocus=true){
    
    
    let {messages} = this.props
    
    this.setState(this.initState({loading:true,pnNo:pnNo}))
    PNDocStore.loadPNDoc(pnNo,docType,(result)=>{
      let data = result.data.itemlist
      if(result.data.itemlist.length<DEFAULT_ROW){
        data = data.concat(this.newEmptyRow(DEFAULT_ROW-result.data.itemlist.length))
      }
      this.pcInput = new Array(data.length).fill('')
      this.setState({loading:false,doc:result.data.doc,data:data,docType:docType})
      
      if(shouldFocus){        
        
      }else{
          this._notificationSystem.addNotification({
            title:messages['Notification'],
            message: messages['Item Changed'],
            level: 'info',
            position:'tc'
          });
        }
    },()=>{
      this.setState({loading:false})
      this._notificationSystem.addNotification({
        title:messages['Notification'],
        message: 'เกิดข้อผิดพลาดในการดึงข้อมูล',
        level: 'error',
        position:'tc'
      });
      this.onCloseClick()
    })
  }

  onPrintClick(){
    let {pnNo,docType} = this.state
    let url = ''
    if (docType==='cashbill') {
      url = './pdf/?iv='+pnNo+'&file=cashbill_doc';
      if (process.env.NODE_ENV === "development") {
        url = 'https://demo2.bigfix.co/okorat/pdf/?iv='+pnNo+'&file=cashbill_doc';
      }
    } else {
      url = './pdf/v2?startPage=PrintPaymentNoteDoc&pn='+pnNo;
      if (process.env.NODE_ENV === "development") {
        url = '?startPage=PrintPaymentNoteDoc&pn='+pnNo;
      }
    }
    this._iframe.loadUrl(url)
  }

  onCustomerClick(){
    this.setState({show:true})
  }

  onInputChange(key,e){
    let {doc} = this.state
    doc[key] = e.target.value
    this.setState({doc:doc})
  }

  onCustomerPageSelect(item){
    let {doc} = this.state
    doc['customer_id'] = item.customer_id
    doc['customer_name'] = item.name
    doc['customer_address'] = item.address
    doc['customer_tel'] = item.tel
    this.setState({doc:doc})
  }

  onDateChange(value){
    let {doc} = this.state
    doc['added_date'] = value
    this.setState({doc:doc})
  }

  onSaveClick(){
    let {pnNo,workNo,doc,data,docType} = this.state        
    let {messages} = this.props
    
    this.setState({loading:true})
    let postData = {}
    if (docType==='cashbill')
      postData = {iv:pnNo,work_no:workNo,doc:doc,itemlist:data}
    else
      postData = {pn:pnNo,work_no:workNo,doc:doc,itemlist:data}
    PNDocStore.savePNDoc(postData,docType,(result)=>{
      doc.seq_no = result.seq_no
      this.setState({loading:false,doc:doc})
      this._notificationSystem.addNotification({
        title:messages['Notification'],
        message: messages['Automatic Saving'],
        level: 'info',
        position:'tc'
      });
      if(this.props.onSaved!==undefined){
        this.props.onSaved(pnNo,docType)
      }
      
    },(error)=>{
           
      this._notificationSystem.addNotification({
        title:messages['Notification'],
        message: messages['Automatic Saving Failed'],
        level: 'error',
        position:'tc'
      });
      this.setState({loading:false,errorShow:true})
    })
    
  }

  onCloseClick(){
    
    
    if(this.props.onClose!==undefined){
      this.props.onClose()
    }
  }

  onDeleteRowClick(index){
    let {data} = this.state

    data.splice(index,1);  
    this.setState({data:data})    
    
    
  }

  summaryAmount(data){
    let amount = 0
    data.forEach((item,index)=>{
      amount += item.amount*1
    })
    return amount
  }

  onFormChange(index,key,e){
    let {doc,data} = this.state
    let value = e.target.value
    data[index][key] = value
    if(['quantity','price_per_unit'].includes(key)){
      data[index]['amount'] = data[index]['quantity']*data[index]['price_per_unit']
      doc['amount'] = this.summaryAmount(data)      
    }
    this.setState({doc:doc,data:data})
  }

  onRowAdd(number){
    let {data} = this.state
    
    
    data = data.concat(this.newEmptyRow(number))

    this.pcInput = new Array(data.length).fill('')
    this.setState({data:data})
  }

  
  onTypeaheadInputChange(index,query){
    //console.log('typeChagne',e,text)
    //console.log("query",query)
    let {data} = this.state
    data[index]['detail'] = query
    
    
    this.setState({data:data})
  }

  

  onTextKeyPress(index,key,target) {
    if(target.charCode===13){
      this.onSaveClick()
    }
  }

 

  onMenuItemSelect(index){
    let {messages} = this.props
    let {pnNo,doc,data} = this.state
    
    if('deleteso'===index){
      // console.log('delete PO',pnNo)      
      this.setState({loading:true})
      PNDocStore.delPNDoc(pnNo,(result)=>{
        this.setState({loading:false})
        this.onCloseClick()
      })
    }else if('cancelorder'===index){
      // console.log('delete PO',pnNo)      
      this.setState({loading:true})
      PNDocStore.cancelPNDoc(pnNo,doc.stock_recordid,(result)=>{
        doc.canceled = 1
        this.setState({loading:false,doc:doc})  
        this._notificationSystem.addNotification({
          title:messages['Notification'],
          message: 'ยกเลิกรายการสินค้าเรียบร้อยแล้ว',
          level: 'info',
          position:'tc'
        });      
      },()=>{

      })
    }else if("payment"===index){
         
      // if (that.onSaveClick()) {
      //   this.setState({loading:true})
      //   let postData = {so:pnNo,status:'1'}
      //   PNDocStore.updatePNDocStatus(postData,function(result){
      //     doc['status'] = '1'
      //     that.setState({loading:false,doc:doc})
      //   }) 
      // } 

      this.savePNDoc(doc,data,()=>{
        this.setState({loading:true})
        let postData = {so:pnNo,status:'1'}
        PNDocStore.updatePNDocStatus(postData,(result)=>{
          doc['status'] = '1'
          this.setState({loading:false,doc:doc})

          this._notificationSystem.addNotification({
            title:messages['Notification'],
            message: messages['Payment Status Adjustment'],
            level: 'info',
            position:'tc'
          });
        },()=>{
          //Status Fail
          this.setState({loading:false})
        }) 
      },function(){
        //Show Error
      })

    }else if("credit"===index){
      
      // if (that.onSaveClick()) { 
      //   this.setState({loading:true})
      //   let postData = {so:pnNo,status:'2'}
      //   PNDocStore.updatePNDocStatus(postData,function(result){
      //     doc['status'] = '2'
      //     that.setState({loading:false,doc:doc})
      //   })  
      // }  
      this.savePNDoc(doc,data,function(){
        this.setState({loading:true})
        let postData = {so:pnNo,status:'2'}
        PNDocStore.updatePNDocStatus(postData,(result)=>{
          doc['status'] = '2'
          this.setState({loading:false,doc:doc})

          this._notificationSystem.addNotification({
            title:messages['Notification'],
            message: messages['Credit Status Adjustment'],
            level: 'info',
            position:'tc'
          });
        },()=>{
          //Status Fail
          this.setState({loading:false})
        }) 
      },function(){
        //Show Error
      })  
    }else if("receipt"===index){
      this.setState({showHistory:true})
      this.refs.saleHist.getWrappedInstance().loadData(index,messages['Receipt'],pnNo)
    }else if("taxinvoice"===index){
      this.setState({showHistory:true})
      this.refs.saleHist.getWrappedInstance().loadData(index,messages['Tax Invoice'],pnNo)
    }else if("cashbill"===index){
      this.setState({showHistory:true})
      this.refs.saleHist.getWrappedInstance().loadData(index,messages['Cash Bill'],pnNo)
    }
  }

  getValidationState() {
    const length = this.state.shopName.length;
    if (length > 10) return 'success';
    else if (length > 5) return 'warning';
    else if (length > 0) return 'error';
  }

  _renderMenuItemChildren(option, props, index) {
    let {messages} = this.props
    let quantityTitle = ''
    if(option.quantity>0){
      quantityTitle = ' '+messages['Have Number']+' '+option.quantity+' '+option.unit
    }

    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} ({messages['Category']}{option.categoryName}) - {option.pricePerUnit} {messages['Bath']} {quantityTitle}</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail} {quantityTitle}</span>
        </div>
      );
    }
  }

  renderHeaderRow(){
    let {messages} = this.props
    let {customer_name,customer_address,added_date,customer_tel} = this.state.doc
    return (
      <div>
        <Row>
          <Col md={3}>
            <FormGroup
              validationState={this.getValidationState()}
            >
              <ControlLabel>{messages['Customer']} :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='user'/></InputGroup.Addon>
                <FormControl value={customer_name} onChange={this.onInputChange.bind(this,'customer_name')}/>
                <InputGroup.Addon onClick={this.onCustomerClick.bind(this)}><FontAwesome name='plus'/></InputGroup.Addon>
              </InputGroup>            
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup
              validationState={this.getValidationState()}
            >
              <ControlLabel>{messages['Address']} :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='location-arrow'/></InputGroup.Addon>
                <FormControl value={customer_address} onChange={this.onInputChange.bind(this,'customer_address')}/>
              </InputGroup>            
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup
              validationState={this.getValidationState()}
            >
              <ControlLabel>{messages['Date']} :</ControlLabel>
              <DatePicker
                  showIcon={true}
                  showFooter={true}
                  popPlacement='bottom'
                  buddhistEra
                  value={added_date} 
                  onChange={this.onDateChange.bind(this)}
                  maxWidth={'100%'}
                  inline={false}
              />            
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <FormGroup>
              <ControlLabel>{messages['Phone']} :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='phone'/></InputGroup.Addon>
                <FormControl value={customer_tel} onChange={this.onInputChange.bind(this,'customer_tel')}/>
              </InputGroup>            
            </FormGroup>
          </Col>
        </Row>
      </div>
    )
  }

  renderRemark(){
    let {remark} = this.state.doc
    let {messages} = this.props
    return (
      <Row>
      <Col md={3}>
        <FormGroup
          validationState={this.getValidationState()}
        >
          <ControlLabel>{messages['Note']} </ControlLabel>
          <InputGroup>            
            <FormControl value={remark} componentClass="textarea" style={{width:'400px',height:'150px'}}
             onChange={this.onInputChange.bind(this,'remark')}/>            
          </InputGroup>            
        </FormGroup>
      </Col>
      </Row>
    )
  }

  getRowClassName(item,index){
    // let {rowBeep} = this.state
    let className = ""
    return className
  }

  renderRowData(){
    // let {messages} = this.props
    let {data} = this.state
    return data.map((item,index)=>(
      <tr key={index} className={this.getRowClassName(item,index)}>
        <td className='text-center'>{index+1}</td>
        
        <td className='data-column'>               
                  <FormControl 
        value={item.detail} 
        onChange={this.onFormChange.bind(this,index,'detail')}        
        />
        </td>
        
        <td  className='data-column text-center'>
        <FormControl className='text-center' 
        value={item.quantity} 
        onChange={this.onFormChange.bind(this,index,'quantity')}
        onKeyPress={this.onTextKeyPress.bind(this,index,'quantity')}
        />
        </td>
        <td className='data-column text-right'><FormControl className='text-right' 
        value={item.price_per_unit} 
        onChange={this.onFormChange.bind(this,index,'price_per_unit')}
        onKeyPress={this.onTextKeyPress.bind(this,index,'price_per_unit')}
        /></td>
        <td className='data-column text-right'>{item.amount}</td>
        <td className='text-center'><Button bsStyle={'danger'} onClick={this.onDeleteRowClick.bind(this,index)}><FontAwesome name='trash'/></Button></td>
      </tr>
    ))

  }


  renderTable(){
    let {messages} = this.props
    let {doc} = this.state
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>{messages['Number']}</th>
            
            <th>{messages['Item']}</th>
            
            <th className='text-center' style={{width:'70px'}}>{messages['Quantity']}</th>
            <th className='text-center' style={{width:'120px'}}>{messages['Price/Unit']}</th>
            <th className='text-center' style={{width:'120px'}}>{messages['Amount']}</th>
            <th className='text-center' style={{width:'30px'}}>{messages['Delete']}</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        <tfoot>
          <tr >            
            <th colSpan={4} className='text-right'>{messages['Total Amount']}</th>
            <th className='text-right'>{doc.amount}</th>
            <th className='text-right'></th>
        </tr>
        </tfoot>
      </table>
    )
  }

  renderNewItemButton(){
    let {messages} = this.props
    return (
      <div style={{display:'inline-flex'}}>
        <ButtonToolbar>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;{messages['Add Item']}</Button>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;{messages['Add 10 Item']}</Button>
        </ButtonToolbar>
        
      </div>
    )
  }

  renderDocMenu(){
    let {messages} = this.props
    
    let title = (<span><i className="fa  fa-edit"></i>&nbsp;{messages['Create Document']}</span>)

    
    return (
      
        
          <SplitButton bsStyle={'primary'} title={title}  onSelect={this.onMenuItemSelect.bind(this)}>
            <MenuItem eventKey="receipt"><FontAwesome name='file-text-o' className='text-green'/>{messages['Receipt']}</MenuItem>
            <MenuItem eventKey="taxinvoice"><FontAwesome name='file-text-o' className='text-green'/>{messages['Tax Invoice']}</MenuItem>
            <MenuItem eventKey="cashbill"><FontAwesome name='file-text-o' className='text-green'/>{messages['Cash Bill']}</MenuItem>
          </SplitButton>
        
      
    )
  }

  renderStatus(){
    let {doc} = this.state
    let {messages} = this.props
    if(doc.status==='1'){
      return (<span className='label label-success'>{messages['Already Paid']}</span>)
    }else  if(doc.status==='2'){
      return (<span className='label label-primary'>{messages['Credit']}</span>)
    }else{
      return (<span/>)
    }

  }

  renderStockStatus(){
    let {messages} = this.props
    let {doc} = this.state
    if(doc.stock_recordid*1>0){
      return (<span className='label label-default'>{messages['Cut Stock']}</span>)
    }else{
      return (<span/>)
    }
  }

  renderCancelStatus(){
    // let {messages} = this.props
    let {doc} = this.state
    if(doc.canceled*1===1){
      if(doc.stock_recordid*1>0){
        return (<div style={{display:'inline'}}><span className='label label-danger'>{'ยกเลิกรายการ'}</span><span className='label label-default'>{'คืนสินค้าเข้าคลัง'}</span></div>)
      }else{
        return (<span className='label label-danger'>{'ยกเลิกรายการ'}</span>)
      }
    }else{
      return (<span/>)
    }
  }

  render(){
    let {messages} = this.props
    let {loading,show,doc,docType} = this.state
    // let title = (<span><i className="fa  fa-check-square-o"></i>&nbsp;{messages['Status']}</span>)
    let showSave = (true)
    // let cancel = (doc.canceled*1===1)
    return (
      <Box loading={loading}>
        <Box.Header  className='text-center'>
          <Box.Title>
            {docType==='cashbill'?'บิลเงินสด':'ใบรายการรับเงิน'}{this.renderStatus()}  {this.renderStockStatus()}  {this.renderCancelStatus()}               
          </Box.Title>
          <Box.Tools className='pull-right' >
            
            <ButtonToolbar style={{display:doc.seq_no>0?'block':'none'}}>                                            
              <Button className='bg-maroon'                       
              	onClick={this.onPrintClick.bind(this)}
              >
               	<FontAwesome name='print'/>&nbsp;{messages['Print Document']}
              </Button>              
            </ButtonToolbar>                     
          </Box.Tools> 
        </Box.Header>
        <Box.Body>
          {this.renderHeaderRow()}
          {this.renderTable()}
          {this.renderNewItemButton()}
          {this.renderRemark()}
          <SWTNewCustomerPopup show={show} onHide={()=>{this.setState({show:false})}}
            onSelect={this.onCustomerPageSelect.bind(this)}
            />
          
            <NotificationSystem ref="notificationSystem" /> 
            <IframeModal ref='iframe'  title={'พิมพ์เอกสาร'} /> 
        </Box.Body>
        <Box.Footer>
          <ButtonToolbar className='pull-right'>
            <Button style={{display:showSave?'block':'none'}} bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;{messages['Save']}</Button>
            <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;{messages['Close']}</Button>
          </ButtonToolbar>
        </Box.Footer>
      </Box>
    )
  }
}


export default PaymentNoteDoc = connect(
  (state) => ({messages: state.message.view.so.PaymentNoteDoc}),null,null,{withRef:true}
)(PaymentNoteDoc);


// WEBPACK FOOTER //
// ./src/view/so/PaymentNoteDoc.js